// after-www's quiz progress bar, drawn in the flow's own colors, in the
// screen column's gutters, above the screen's <main>.

import ProgressBar from "components/ProgressBar";
import {
  MAIN_GUTTER_CLASS,
  NARROW_MAIN_WIDTH_CLASS,
} from "components/ScreenChrome";

import { quizProgressPercent } from "./progress";

export default function QuizProgressBar({
  questionKey,
}: {
  questionKey: string;
}) {
  const percentage = quizProgressPercent(questionKey);
  return (
    <div className={`${MAIN_GUTTER_CLASS} ${NARROW_MAIN_WIDTH_CLASS} pt-6`}>
      <ProgressBar percentage={percentage} label="Quiz progress" />
    </div>
  );
}
